var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn-ver-localizacao',{attrs:{"cliente":{ latitude: _vm.pedido.latitude, longitude: _vm.pedido.longitude }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-map-marker-outline")]),_c('small',[_vm._v(_vm._s(_vm.pedido.cidade_entrega))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }